<template>
  <div class="data-ingredient">
		<div class="page-header">营养标准</div>
		<div style="padding-right:25px;text-align:right;">
			<span style="display:inline-block;cursor:pointer;" @click="assessRule">
				<i class="el-icon-finished"></i>评估规则
			</span>
		</div>
		<el-row style="padding:15px;">
			<el-col :span="6" v-for="(o, index) in dirsYearList" :key="index" :offset="index > 0 ? 2 : 0">
				<el-card :body-style="{ padding: '0px',cursor:'pointer' }" @click.native="queryDirsList(o.id,o.name,o.detail,o.enable)">
					<div style="text-align: left;
								height: 125px;
								line-height: 125px;
								padding-left: 14px;
								padding-right: 14px;">
						<span>{{o.name}}</span>
						<span style="color:rgb(167 160 160);float:right">{{o.enable==1?'启用':'停用'}}</span>
					</div>
				</el-card>
			</el-col>
		</el-row>
  </div>
</template>

<script>
import { queryDirsYearsList } from '@/api/basis'
export default {
	data() {
		return {
			dirsYearList: []
		}
	},
	created() {
		this.queryDirsYearsList();
	},
	methods: {
		queryDirsYearsList() {
			queryDirsYearsList().then(response=>{
				this.dirsYearList = response.data;
			})
		},
		queryDirsList(id,name,detail,enable) {
			this.$router.replace({path: '/datacenter/basis/dirslist',query:{id: id,name:name,detail:detail,enable:enable}})
		},
		assessRule() {
			this.$router.replace({path: '/datacenter/basis/assess'})
		}
	}
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/datacenter/components/basedata/basis/index.vue